import { api } from "./api";

export const fetchPromotions = () =>
  api.get("/promotion-focus").then((r) => r.data);

export const fetchPromotion = (id) =>
  api.get(`/promotion-focus/${id}`).then((r) => r.data);

export const fetchActivePromotion = () =>
  api.get("/promotion-focus/active").then((r) => r.data);

export const createPromotion = (data) =>
  api.post("/promotion-focus", data).then((r) => r.data);

export const updatePromotion = (id, data) =>
  api.patch(`/promotion-focus/${id}`, data).then((r) => r.data);
